<template>
  <div class="card">
    <div class="badges">
      <div v-if="plan.discountPercent > 0" class="badge badge-primary">
        Save Over {{ plan.discountPercent }}%
      </div>
    </div>
    <div class="plan-header">
      <div class="plan-header-left">{{ plan.displayName }}</div>
      <div class="plan-header-right">&nbsp;</div>
    </div>
    <div class="plan-price">
      {{ plan.breakdownPrice }}
      <span>/month</span>
    </div>
    <div class="plan-billing">
      Billed {{ plan.billingFrequency === 'monthly' ? 'monthly': `at ${plan.displayPrice} ${plan.billingFrequency === 'semi-annually' ? 'every 6 months': 'annually'}` }}
    </div>
    <div class="badges">
      <div v-if="plan.trialPeriodDays > 0" class="badge badge-secondary">7-day free trial</div>
    </div>
    <div class="bullets">
      <div class="bullet">
        <img
          width="20"
          height="20"
          src="../../assets/images//plans/Icon-Check.svg"
          alt="check" />
        <div class="text">Unlimited access on the Luminary App and LuminaryPodcasts.com.</div>
      </div>
      <div class="bullet">
        <img
          width="20"
          height="20"
          src="../../assets/images//plans/Icon-Check.svg"
          alt="check" />
        <div class="text">Exclusive content and early-access.</div>
      </div>
      <div class="bullet">
        <img
          width="20"
          height="20"
          src="../../assets/images//plans/Icon-Check.svg"
          alt="check" />
        <div class="text">Ad-free listening to all Luminary Originals.</div>
      </div>
      <div class="bullet">
        <img
          width="20"
          height="20"
          src="../../assets/images//plans/Icon-Check.svg"
          alt="check" />
        <div class="text">No visual ads, ever.</div>
      </div>
      <div :class="{'invisible': plan.billingFrequency === 'semi-annually'}" class="bullet">
        <img
          width="20"
          height="20"
          src="../../assets/images//plans/Icon-Check.svg"
          alt="check" />
        <div v-if="plan.billingFrequency === 'monthly'" class="text text-primary">Flexible month-to-month billing</div>
        <div v-else-if="plan.discountPercent > 0" class="text text-primary">{{ plan.discountPercent }}% savings over the monthly plan</div>
      </div>
    </div>

    <el-button :class="{'selected': plan.isBestValue}" @click="onPlanSelect">Continue</el-button>
  </div>
</template>
<script>
export default {
  name: 'E1PlanItem',
  props: {
    plan: {
      type: Object,
      default: () => { },
    },
    isSelected: {
      type: Boolean,
      default: () => false,
    },
    isPlansExtended: {
      type: Boolean,
      default: () => false,
    },
    index: {
      type: Number,
      default: () => 1,
    },
  },
  data() {
    return {};
  },
  computed: {
  },
  methods: {
    onPlanSelect() {
      this.$emit('selectPlan', this.plan);
    },
    onPromoPlanSelect() {
      this.$emit('selectSpecialPromoPlan');
    },
    onSetSelectedPlan() {
      this.$emit('setSelectedPlan', this.index);
    },
    onFootnoteTwoClick() {
      this.$emit('onFootnoteTwoClick');
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../assets/scss/variables.scss";

.card {
    border-radius: 10px;
    color: $white;
    background-color: #192a48;
    min-height: 300px;
    width: 310px;
    padding: 35px;
}

.badges {
    display: flex;
    justify-content: flex-start;
    padding: 0;
    margin: 0;
    min-height: 23px;
}

.badge {
    font-family: $patron-bold;
    font-size: 11px;
    padding: 4px 8px;
    border-radius: 3px;
    color: $black;
    text-transform: uppercase;
    white-space: nowrap;
}

.badge-primary {
    background-color: #FFE500;
}

.badge-secondary {
    background-color: #5289ed;
    color: $white;
}

.plan-header {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-top: 22px;
    column-gap: 20px;

    .plan-header-left {
        font-size: 20px;
        font-family: $patron-bold;
    }

    .plan-header-right {
        height: 1px;
        flex: 1 1 auto;
        min-width: 190px;
        background: #FEFEFC;
        opacity: .21;
    }
}

.plan-price {
    margin-top: 20px;
    font-size: 40px;
    font-family: $patron-bold;

    span {
        font-size: 20px;
        font-family: $patron;
    }
}

.plan-billing {
    color: #727D8F;
    font-size: 16px;
    font-family: $patron;
    margin-top: 7px;
    margin-bottom: 20px;
}

button {
    width: 100%;
    margin-top: 62px;
    padding: 18px;
    font-size: 20px;
    font-family: $patron-bold;
    color: $white;
    background: none;

    &.selected {
        background-color: $brand !important;
        border: 1px solid $brand !important;
        font-family: $patron-bold !important;
        font-size: 20px !important;
        color: $black;

        &:hover {
            background: darken($color: $brand, $amount: 20%) !important;
            border-color: darken($color: $brand, $amount: 20%) !important;
        }
    }
}

.bullets {
  margin-top: 30px;
  display: none;

  .bullet {
    margin-top: 17px;
    display: flex;
    justify-content: flex-start;

    &.invisible {
      visibility: hidden;
    }

    .text {
      margin-left: 10px;
      font-size: 16px;
      font-family: $patron;
      color: #727D8F;
    }

    .text-primary {
      color: #5289ed;
    }
  }
}

@media only screen and (max-width: 1024px) {
    .card {
        padding: 25px;
        width: 100%;
        max-width: 310px;

        button {
          margin-top: 42px;
        }
    }
}

@media only screen and (max-width: 400px) {
    .card {
        max-width: 280px;
    }

    .bullets .bullet .text {
      font-size: 14px;
    }
}
</style>
